import React, {useState, useMemo} from "react";
import "./parts.css"; // On ajoute un fichier CSS pour le style
import SwitchToggle from "../../components/SwitchToggle";
import ItemResolver from "../../preview/items/ItemResolver";
import { getTriggerBuild } from "../../triggers/gamefactTriggersService";
import DsasButton from "../../../../../components/DsasButton/DsasButton";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Box, Dialog } from "@mui/material";

const SelectEnableTrigger = ({ event, onChange, directEvent }) => {
  const [isOpen, setIsOpen] = useState(false);

  const importPreview = useMemo(() => {

    return getTriggerBuild(event, directEvent)

  }, [event, directEvent])

  
  return (
    <Box className="small-padding">

      {event.hasOwnProperty("isEnableTrigger") && (
        <SwitchToggle
          label={"Sondage automatique"}
          checked={event.isEnableTrigger}
          onSwitch={(value) => onChange("isEnableTrigger", value)}
        />
      )}

      {event.isEnableTrigger && importPreview && <>
      {/* Bouton d'ouverture */}

      <Box className="centered-wrapper">
        <DsasButton
          label='Prévisualisation' 
          variant = 'secondary'
          icon={faEye}
          onClick={() =>  setIsOpen(true)}
        ></DsasButton>
      </Box>

      {/* Popup */}
      <Dialog onClose={() => setIsOpen(false)} open={isOpen}>
        <Box padding={3} alignItems="center" textAlign={"center"}>
            <button className="close-btn" onClick={() => setIsOpen(false)}>✖</button>
            <div style={{padding : '10px'}}>
              <ItemResolver item={importPreview} match={directEvent} />
            </div>
        </Box>
      </Dialog>
      </>}
    </Box>
  );
};

export default SelectEnableTrigger;
